// mui components
import { FormValues } from '@features/createDeviceConfiguration/type/FormValues';
import { Checkbox, Typography, Grid } from '@mui/material';

// use form hook
import { Control, Controller } from 'react-hook-form';

interface FormCheckboxProps {
  name: string;
  control: Control<FormValues>;
  label: string;
  disabled?: boolean;
}

export const FormCheckbox = ({
  name,
  control,
  label,
  disabled = false,
}: FormCheckboxProps) => {
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography color="textSecondary">{label}</Typography>
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, value } }) => (
            <Checkbox
              disabled={disabled}
              checked={value}
              onChange={(e) => onChange(e.target.checked)}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};
